import { ArrowRight } from "lucide-react";
import { AppLink, Avatar, Tag } from "@amber/ui";
import type { TaskRow } from "../../contracts/index";

const PLATFORM_CODES: Record<string, string> = {
  YouTube: "YT",
  Podcast: "RSS",
  Web: "WEB",
  Parliament: "PARL",
  Broadcaster: "TV",
  X: "X",
  Instagram: "IG",
  News: "NEWS",
};

function platformCode(platform: string): string {
  return PLATFORM_CODES[platform] ?? platform.slice(0, 4).toUpperCase();
}

export function Subject({ task }: { task: TaskRow }) {
  return (
    <span className="flex items-center gap-1" title={[...task.people.map((p) => p.name), ...task.platforms].join(", ")}>
      {task.people.slice(0, 3).map((p) => (
        <Avatar key={p.key} name={p.name} />
      ))}
      {task.platforms.slice(0, 1).map((p) => (
        <Tag key={p} tone="quiet" className="font-mono uppercase">
          {platformCode(p)}
        </Tag>
      ))}
      <span className="sr-only">{[...task.people.map((p) => p.name), ...task.platforms].join(", ")}</span>
    </span>
  );
}

export function HandledIn({ task }: { task: TaskRow }) {
  if (!task.handled_in) return <>—</>;
  if (!task.handled_in.href) return <span>{task.handled_in.label}</span>;
  return (
    <AppLink
      href={task.handled_in.href}
      className="inline-flex items-center gap-1 font-strong text-link no-underline hover:underline"
    >
      {task.handled_in.label}
      <ArrowRight size={12} strokeWidth={1.8} aria-hidden="true" />
    </AppLink>
  );
}

export function TaskTitle({ task }: { task: TaskRow }) {
  return (
    <span className="block min-w-0 leading-tight">
      <span className="block truncate font-strong text-fg">{task.title}</span>
      <span className="block truncate text-md text-muted">{task.context}</span>
    </span>
  );
}
